"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "nuvolera": {
    "6f21150f": [{
      "hkey": "de8d5c5a",
      "slug": "nuvolera",
      "name": "Nuvolera",
      "primary": true,
      "skipSearch": false
    }],
    "bettoletto": [{
      "hkey": "de8d5c5a",
      "slug": "nuvolera",
      "name": "Nuvolera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "51115bb0": [{
      "hkey": "de8d5c5a",
      "slug": "nuvolera",
      "name": "Nuvolera",
      "primary": true,
      "skipSearch": false
    }],
    "casella": [{
      "hkey": "de8d5c5a",
      "slug": "nuvolera",
      "name": "Nuvolera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ece004de": [{
      "hkey": "de8d5c5a",
      "slug": "nuvolera",
      "name": "Nuvolera",
      "primary": true,
      "skipSearch": false
    }],
    "localita-camprelle": [{
      "hkey": "de8d5c5a",
      "slug": "nuvolera",
      "name": "Nuvolera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c6502c8c": [{
      "hkey": "de8d5c5a",
      "slug": "nuvolera",
      "name": "Nuvolera",
      "primary": true,
      "skipSearch": false
    }],
    "molvina": [{
      "hkey": "de8d5c5a",
      "slug": "nuvolera",
      "name": "Nuvolera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c075e51a": [{
      "hkey": "de8d5c5a",
      "slug": "nuvolera",
      "name": "Nuvolera",
      "primary": true,
      "skipSearch": false
    }],
    "sorzana": [{
      "hkey": "de8d5c5a",
      "slug": "nuvolera",
      "name": "Nuvolera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;